import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from '@marvelapp/hooks';
import { SEARCH_ICON } from '@marvelapp/theme';
import Box from '../Box';
import EscKeyHandler from '../EscKeyHandler';
import Flex from '../Flex';
import Icon from '../Icon';
import Input from '../Input';
import PinTL from '../PinTL';
import Position from '../Position';
import SearchCloseButton from '../SearchCloseButton';
import { SearchIcon } from './styles';
/** @types any */
var SearchInput = function (_a) {
    var autoFocus = _a.autoFocus, isDisabled = _a.isDisabled, _b = _a.searchTerm, searchTerm = _b === void 0 ? '' : _b, onChange = _a.onChange, onOpen = _a.onOpen, onClose = _a.onClose, _c = _a.testId, testId = _c === void 0 ? 'search-input-box' : _c, onToggle = _a.onToggle, rest = __rest(_a, ["autoFocus", "isDisabled", "searchTerm", "onChange", "onOpen", "onClose", "testId", "onToggle"]);
    var _d = __read(useState(autoFocus || searchTerm), 2), isSearchOpen = _d[0], setIsSearchOpen = _d[1];
    var _e = __read(useState(searchTerm), 2), inputValue = _e[0], setInputValue = _e[1];
    useEffect(function () {
        if (onToggle) {
            onToggle(isSearchOpen);
        }
    }, [isSearchOpen, onToggle]);
    var textInputRef = useRef();
    var ref = useRef();
    useOnClickOutside(ref, function () {
        if (isSearchOpen && !searchTerm && !isDisabled) {
            closeInput();
            textInputRef.current.blur();
        }
    });
    function onIconClick() {
        if (!isSearchOpen) {
            openInput();
            textInputRef.current.focus();
        }
        else {
            closeInput();
        }
    }
    function handleEscKey() {
        closeInput();
        textInputRef.current.blur();
    }
    function openInput() {
        if (!isDisabled) {
            setIsSearchOpen(true);
            if (onOpen)
                onOpen();
        }
    }
    function closeInput() {
        if (!isDisabled) {
            setIsSearchOpen(false);
            if (searchTerm !== '') {
                onChange('');
                setInputValue('');
            }
            if (onClose)
                onClose();
        }
    }
    return (React.createElement(Box, { ref: ref, width: [1, 1, 'auto'] },
        React.createElement(Position, { position: "relative", width: [1, 1, 'auto'] },
            isSearchOpen && React.createElement(EscKeyHandler, { onEscapeKey: handleEscKey }),
            React.createElement(Position, { bg: "white", position: "absolute", right: isSearchOpen ? '-1px' : 0, top: 0, zIndex: isSearchOpen ? 'popover' : 'unset' },
                React.createElement(Input, __assign({ autoFocus: autoFocus, bg: "white", boxShadow: isSearchOpen
                        ? 'input.default'
                        : ['input.default', 'input.default', 'none'], "data-testid": testId, hasTransition: false, onChange: function (e) {
                        onChange(e.target.value);
                        setInputValue(e.target.value);
                    }, pl: 36, pointerEvents: isDisabled ? 'none' : 'all', pr: isSearchOpen ? 3 : 0, ref: textInputRef, size: 2, value: inputValue, width: isSearchOpen ? [1, 1, 200, 310] : [1, 1, 0] }, rest)),
                isSearchOpen && searchTerm && (React.createElement(SearchCloseButton, { onClick: onIconClick })),
                isSearchOpen && (React.createElement(PinTL, null,
                    React.createElement(SearchIcon, { isDisabled: isDisabled, isSearchOpen: isSearchOpen, onClick: onIconClick },
                        React.createElement(Icon, { "data-testid": "search-icon", height: 24, paths: SEARCH_ICON, width: 24 }))))),
            React.createElement(Flex, { alignItems: ['flex-start', 'flex-start', 'center'], flexDirection: ['column', 'column', 'row'] },
                React.createElement(SearchIcon, { "data-testid": "search-icon-wrapper", isDisabled: isDisabled, isSearchOpen: isSearchOpen, onClick: onIconClick },
                    React.createElement(Icon, { "data-testid": "search-icon", height: 24, paths: SEARCH_ICON, width: 24 }))))));
};
export default SearchInput;
